import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

function FuelTypeDropdown({
  value,
  onChange,
  options = [],
  className = "",
  placeholder = "Select Fuel Type",
  disabled = false,
  disableClearable = false,
  ...props
}) {
  const commonSx = {
    '& .MuiInputBase-root': {
      height: '40px',
      padding: '0 8px',
    },
    '& .MuiOutlinedInput-root': {
      paddingRight: '39px !important',
    },
    width: '100%',
    '& .MuiAutocomplete-input': {
      padding: '7.5px 4px !important',
    }
  };

  return (
    <Autocomplete
      value={value}
      onChange={(event, newValue) => onChange && onChange(newValue)}
      options={options}
      getOptionLabel={option => option?.label || ""}
      isOptionEqualToValue={(option, val) => option?.value === val?.value}
      size="small"
      className={className}
      disabled={disabled}
      sx={commonSx}
      clearOnEscape
      disableClearable={disableClearable}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
        />
      )}
      ListboxProps={{
        style: { maxHeight: "150px" },
      }}
      {...props}
    />
  );
}

export default FuelTypeDropdown;